import React from 'react';
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  CheckCircleIcon,
} from '@heroicons/react/24/outline';

/**
 * WizardNavigation
 *
 * Props:
 *   currentStep        — raw internal step (1–5)
 *   displayStep        — visual step shown to user (accounts for Path C skip)
 *   totalSteps         — 4 for Path C (scratch), 5 for Paths A & B
 *   canProceed         — function returning boolean
 *   onPreviousStep     — handler (already accounts for skip in parent)
 *   onNextStep         — handler (already accounts for skip in parent)
 *   onSave             — handler for final step
 */
const WizardNavigation = ({
  currentStep,
  displayStep,
  totalSteps = 5,
  canProceed,
  onPreviousStep,
  onNextStep,
  onSave,
}) => {
  const isLastStep = currentStep === 5;

  return (
    <div className="mt-8 flex items-center justify-between pt-6 border-t border-grey-300">
      <button
        onClick={onPreviousStep}
        disabled={currentStep === 1}
        className="px-6 py-3 border border-grey-300 text-darkblue-500 rounded-lg hover:bg-grey-100 transition-colors flex items-center gap-2 font-medium disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <ArrowLeftIcon className="w-5 h-5" />
        Back
      </button>

      {/* Step counter — uses displayStep/totalSteps so Path C shows "3 of 3" not "4 of 4" */}
      <div className="text-sm text-grey-600">
        Step {displayStep ?? currentStep} of {totalSteps}
      </div>

      {!isLastStep ? (
        <button
          data-tour="wizard-continue"
          onClick={onNextStep}
          disabled={!canProceed()}
          className="px-6 py-3 bg-brand-500 text-white rounded-lg hover:bg-brand-600 transition-colors flex items-center gap-2 font-medium disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Continue
          <ArrowRightIcon className="w-5 h-5" />
        </button>
      ) : (
        <button
          data-tour="wizard-save"
          onClick={onSave}
          className="px-6 py-3 bg-teal-500 text-white rounded-lg hover:bg-teal-600 transition-colors flex items-center gap-2 font-medium"
        >
          <CheckCircleIcon className="w-5 h-5" />
          Save Bid
        </button>
      )}
    </div>
  );
};

export default WizardNavigation;